<template>
  <div class="mapdetail">
    <m-title :titlelist="listitem"></m-title>
    <div class="map-title">
      <div>
        <input
          type="text"
          placeholder="请输入车牌"
          v-model="inpval"
          class="inp"
        />
        <button class="search" @click="getmapinfo">搜索</button>

        <button class="search" @click="openOrclose">
          {{ close ? "收起超速车辆" : "查看超速车辆" }}
          <!-- 超速车辆{{ overSpeedCarsList.length }}辆 -->
        </button>
        <button class="search" @click="lookspeeding">查看超速记录</button>
      </div>
      <!-- <div class="close" @click="openOrclose">{{ close ? '收起超速车辆' : '展开超速车辆' }}</div> -->
      <div class="title-right">
        <span style="margin-right: 10px"
          >南航路限速30km/小时，超速车辆<span style="color:#c00000;"> {{ nanHangRoad.length }} </span>辆</span
        >
        <span style="margin-right: 10px"
          >南港路限速60km/小时，超速车辆<span style="color:#c00000;"> {{ nanGangRoad.length }} </span>辆</span
        >
        <img src="@/assets/homeImg/icon_red.png" alt="" />
        <span style="margin: 0 30px 0 10px">超速</span>
        <img src="@/assets/homeImg/icon_truck_blue.png" alt="" />
        <span style="margin-left: 10px">正常</span>
      </div>
    </div>
    <div id="container" style="height: calc(100% - 100px)"></div>
    <div class="platelist">
      <transition name="slide">
        <ul
          v-if="close"
          style="
            display: flex;
            list-style: none;
            flex-direction: column;
            color: green;
            font-size: 80%;
            padding: 0;
            margin: 0;
            height: calc(100% - 30px);
            overflow: auto;
          "
        >
          <li
            @click="getplate(item.plate, index)"
            class="liclass"
            :style="indexactive === index ? 'background: #EEF7F6;' : ''"
            v-for="(item, index) in overSpeedCarsList"
            :key="index"
          >
            车牌:{{ item.plate }}
            <span style="margin-left: 10px">速度:{{ item.speed }}km/小时</span>
          </li>
        </ul>
      </transition>
    </div>
  </div>
</template>

<script>
import mTitle from "@/components/mTitle";
import AMapLoader from "@amap/amap-jsapi-loader";
import dayjs from "dayjs";
import { antiShake } from "@/plugins/other.js";
import coordtransform from "coordtransform";
import queryPtInPolygon from "@/utils/queryPtInPolygon.js";

const plate_re = new RegExp(
  "^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$"
);
const plate_re_xin = new RegExp(
  "[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF])|([DF][A-HJ-NP-Z0-9][0-9]{4}))"
);
export default {
  components: {
    mTitle,
  },
  data() {
    return {
      listitem: [{ name: "地图" }],
      inpval: "",
      carlist: [],
      energylist: [],
      gapStationlist: [],
      searchlist: [],
      map: null,
      lat: 38.969557,
      lng: 117.769324,
      searchinfo: {},
      intervalTime: null,
      markers: [],
      infoWindow: null,
      platelist: [],
      fleetname: "",
      pno: "",
      indexactive: "",
      overSpeedCarsList: [],
      nanHangRoad: [],
      nanGangRoad: [],
      close: false,
      pagination: {
        limit: 5,
        page: 1,
      },
      fence_list: [],
      fenceDatalist: [],
      circle: null,
      polygon: null,
    };
  },
  mounted() {
    clearInterval(this.intervalTime)
    this.intervalTime=setInterval(this.getFenceDataTimer, 30000)
    this.getFenceData(true);
  },
  beforeDestroy() {
    clearInterval(this.intervalTime);
  },
  computed: {
    fenceArr() {
      return this.fenceDatalist.map((fence) =>
        fence.longitudeLatitude.map((it) => {
          const [x, y] = it || [];
          return { x, y };
        })
      );
    },
  },
  methods: {
    lookspeeding() {
      this.$router.push({
        path: "/member/lookspeeding",
      });
    },
    carIsInFences(item) {
      const [x, y] = coordtransform.wgs84togcj02(item.lng, item.lat);
      for (let i = 0; i < this.fenceArr.length; i++) {
        const isIn = queryPtInPolygon({ x, y }, this.fenceArr[i]);
        if (isIn) {
          return true;
        }
      }
      return false;
    },
    async getData() {
      try {
        const { limit, page } = this.pagination;
        const { data } = await this.$http(
          "api1",
          "/electronicfence/fence/list",
          "get",
          {
            limit,
            page,
            status: 0,
          }
        );
        this.fence_list = data.data.list;
        this.fenceDatalist = [];
        this.fence_list.forEach((item) => {
          let obj = {};
          obj.shape = item.shape;
          obj.electronicFenceName= item.electronicFenceName;
          obj.longitudeLatitude =
            item.shape == "CIRCLE"
              ? item.longitudeLatitude.split(";")
              : item.longitudeLatitude.split(";").map((it) => it.split(","));
          obj.electronicFenceName = item.electronicFenceName;
          this.fenceDatalist.push(obj);
        });
        this.renderFences(this.fenceDatalist);
      } catch (error) {
        console.log("error", error);
        this.fence_list = [];
      }
    },
    openOrclose() {
      if (this.overSpeedCarsList.length > 0) {
        this.close = !this.close;
      }else{
        this.$message("暂无超速车辆！");
      }
    },
    async getplatelist() {
      this.searchlist = [];
      const { data } = await this.$http(
        "api1",
        "home/statistics/mapdisplay",
        "get"
      );
      if (data.code !== 0) return this.$message(data.msg);
      if (data.data.mapEnergyCarVoList.length == 0)
        return this.$message("车辆离线，暂无数据！");
      this.overSpeedCarsList = data.data.overSpeedCars;
      this.nanHangRoad=this.overSpeedCarsList.filter(item=>item.electronicFenceName=='南航路')
      this.nanGangRoad=this.overSpeedCarsList.filter(item=>item.electronicFenceName=='南港路')
      data.data.mapEnergyCarVoList.forEach((item) => {
        const isOverSpeed = this.overSpeedCarsList.some(overSpeedCar => overSpeedCar.plate === item.plate);
        if (isOverSpeed) {
          item.icon = require("/public/homeImg/icon_red.png");
        } else {
          item.icon = require("/public/homeImg/icon_truck_blue.png");
        }
      });
      this.platelist = data.data.mapEnergyCarVoList.filter((item) =>
        this.carIsInFences(item)
      );

      

      this.arrEach([...this.platelist]);
      this.close = false;
      setTimeout(() => {
        this.setLocation();
      }, 500);
    },
    async getFenceData(init) {
      if (init) {
        await this.initMap();
      }

      this.getData().then(() => {
        setTimeout(() => {
          this.getplatelist();
        }, 800);
      });

      // this.getplatelist();
      // setTimeout(() => {
      //   this.getData();
      // }, 500);
    },
    getFenceDataTimer() {
      this.getplatelist();
    },
    getplate(plate, index) {
      this.indexactive = index;
      this.inpval = plate;
      // this.getmapinfo()
      this.$router.push({
        path: "/member/overSpeedDetail",
        query: {
          plate,
        },
      });
    },
    initMap() {
      AMapLoader.reset();
      return AMapLoader.load({
        key: "e1e067886b395ac1aa709c2dd9982e7a", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          // console.log(this.fenceDatalist[0]);
          this.map = new AMap.Map("container", {
            center: [117.8490190362603, 38.95143185123037],
            zoom: 11,
            // mapStyle: "amap://styles/darkblue",
          });
          var trafficLayer = new AMap.TileLayer.Traffic({
            zIndex: 10,
          });
          this.map.add(trafficLayer);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    renderFences(fenceDatalist) {
      if (this.polygon) {
        this.map.remove(this.polygon);
      }
      if (this.circle) {
        this.map.remove(this.circle);
      }
      fenceDatalist.forEach((fence) => {
        if (fence.shape == "CIRCLE") {
          this.circle = new AMap.Circle({
            center: fence.longitudeLatitude.slice(0, 2),
            radius: fence.longitudeLatitude[2],
            bubble: true,
          });
          this.map.add(this.circle);
        } else if (fence.shape == "POLYGON") {
          if(fence.electronicFenceName=='南航路'){
              this.polygon = new AMap.Polygon({
              path: fence.longitudeLatitude,
              draggable: false,
              bubble: true,
              strokeColor: '#fffe6e', // 设置边框颜色
              fillColor: '#ff9901',   // 设置填充颜色
              fillOpacity: 0.35,     // 设置填充透明度
            });
          }else{
            this.polygon = new AMap.Polygon({
              path: fence.longitudeLatitude,
              draggable: false,
              bubble: true,
            });
          }
          
          this.map.add(this.polygon);
        }
      });
      setTimeout(() => {
        this.map.setFitView(null, false);
      }, 1500);
    },
    setLocation() {
      // 渲染多个坐标点
      this.markers.forEach((item) => {
        this.map.remove(item);
      });
      this.markers = [];
      window.Drivings = (plate, startTime, endTime, pno) => {
        this.Drivings(plate, startTime, endTime, pno);
      };
      let that = this;
      this.searchlist.forEach((val) => {
        var markerContentstyle = val.cartype
          ? `
        <div class="map-info" style="font-size:80%;padding:10px 25px 10px 10px">
          <div class="info-item" style="margin-bottom: 10px;">
          <span>车牌号:</span>
          <span>${val.title || "--"}</span>
          </div>
          <div class="info-item" style="margin-bottom: 10px;">
          <span>车辆状态:</span>
          <span>${val.vehstate || "--"}</span>
          </div>
          <div class="info-item" style="margin-bottom: 10px;">
          <span>车辆时速:</span>
          <span>${val.speed || "0"}km/小时</span>
          </div>
          <div class="info-item" style="margin-bottom: 10px;">
          <span>剩余电量:</span>
          <span>${val.soc || "--"}%</span>
          </div>
          <div class="info-item" style="margin-bottom: 10px;">
          <span>车辆类型:</span>
          <span>${val.cartype || "--"}</span>
          </div>
          <div class="info-item" style="margin-bottom: 10px;">
          <span>排放标准:</span>
          <span>${val.discharge || "--"}</span>
          </div>
          <div class="info-item" style="margin-bottom: 20px;">
          <span>所属车队:</span>
          <span>${val.shortname || "--"}</span>
          </div>
          <div class="line"></div>
          <el-button type="primary" 
                     style="background: linear-gradient(0deg, #28C0C7 0%, #33D9A4 100%); border-radius: 5px;cursor: pointer; color: #fff;padding: 5px 10px;font-size: 14px;" onClick="Drivings('${
                       val.title
                     }','${val.startworkdate}','${val.endworkdate}','${
              that.pno
            }')">查看车辆轨迹 ></el-button>
        </div>
      `
          : "";

        // if (!this.map) return
        let position;
        if (val.belongCarFactory == "吉利") {
          position = new AMap.LngLat(val.position[0], val.position[1]); // Marker经纬度
        } else {
          position = coordtransform.wgs84togcj02(
            val.position[0],
            val.position[1]
          );
        }

        const marker = new AMap.Marker({
          position: position,
          // content: markerContent, // 将 html 传给 content
          icon: val.icon,
          // title: val.cartype?`${val.title || "--"}
          // 车牌号：${val.title || "--"}   车辆状态:${val.vehstate || "--"}
          // 剩余电量：${val.soc || "--"}%   车辆类型:${val.cartype || "--"}
          // 排放标准:${val.discharge || "--"}   所属车队:${val.shortname || "--"}
          // `:`${val.title || "--"}`,
          title: val.title,
        });
        this.markers.push(marker);

        this.map.add(marker);
        const infoWindow = new AMap.InfoWindow({
          position: position,
          // offset: new AMap.Pixel(20, -10),
          content: markerContentstyle,
        });
        let _this = this;
        this.infoWindow = infoWindow;
        marker.on("click", function () {
          infoWindow.open(_this.map);
        });
        // this.map.setFitView(null, false);
      });
    },
    async getmapinfo() {
      antiShake((_) => {
        if (this.inpval) {
          if (plate_re.test(this.inpval) || plate_re_xin.test(this.inpval)) {
            this.carlist = this.platelist.filter(
              (item) => item.plate == this.inpval
            );
            this.searchlist = [];
            console.log(this.carlist);
            this.carlist.forEach((item) => {
              const isOverSpeed = this.overSpeedCarsList.some(overSpeedCar => overSpeedCar.plate === item.plate);
              if (isOverSpeed) {
                item.icon = require("/public/homeImg/icon_red.png");
              } else {
                item.icon = require("/public/homeImg/icon_truck_blue.png");
              }
            });
            this.arrEach([...this.carlist]);
            this.lat = this.carlist.lat;
            this.lng = this.carlist.lng;
            setTimeout(() => {
              this.setLocation();
              if (this.inpval) {
                this.infoWindow.open(this.map);
              }
            }, 500);
          } else {
            return this.$message("请输入正确车牌号");
          }
        } else {
          this.getplatelist();
        }
      });
    },
    arrEach(arr) {
      return arr.forEach((item) => {
        let obj = {
          position: [],
          title: "",
          icon: "",
        };
        obj.position[0] = item.lng;
        obj.position[1] = item.lat;
        obj.title = item.plate;
        obj.icon = item.icon;
        obj.speed = item.speed ? item.speed : 0;
        obj.vehstate = item.vehstate ? item.vehstate : "";
        obj.soc = item.soc ? item.soc : "";
        obj.cartype = item.cartype ? item.cartype : "";
        obj.discharge = item.discharge ? item.discharge : "";
        obj.shortname = item.shortname ? item.shortname : "";
        obj.belongCarFactory = item.belongCarFactory
          ? item.belongCarFactory
          : "";
        obj.startworkdate = item.startworkdate
          ? this.mydateFormat(item.startworkdate, "时分秒")
          : "";
        obj.endworkdate = item.endworkdate
          ? this.mydateFormat(item.endworkdate, "时分秒")
          : dayjs(new Date().getTime()).format("YYYY-MM-DD HH:mm:ss");
        this.searchlist.push(obj);
      });
    },
    getsearchinfo(e, plate) {
      if (plate) {
        this.inpval = plate;
      }
      this.searchinfo = this.searchlist.find((item) => {
        return item.title == this.inpval;
      });
      if (plate_re.test(this.inpval) || plate_re_xin.test(this.inpval)) {
        if (this.searchinfo) {
          this.lng = this.searchinfo.position[0];
          this.lat = this.searchinfo.position[1];
          this.searchlist.forEach((item) => {
            if (item.title == this.inpval) {
              item.icon = require("/public/homeImg/icon_truck_blue.png");
            }
          });
          this.map.add(this.searchlist);
          this.setLocation();
          setTimeout(() => {
            // if(this.inpval){
            this.infoWindow.open(this.map);
            // }
          }, 500);
          // this.infoWindow.open(this.map)
          // this.setLocation()
          // this.inpval = ""
        } else {
          this.$message("请输入正确名称");
        }
      } else {
        if (this.searchinfo) {
          this.lng = this.searchinfo.position[0];
          this.lat = this.searchinfo.position[1];
          this.searchlist.forEach((item) => {
            if (item.title == this.inpval) {
              item.icon = require("/public/homeImg/icon_jqz_n.png");
            }
          });
          this.map.add(this.searchlist);
          this.setLocation();
          // this.inpval = ""
        } else {
          this.$message("请输入正确名称");
        }
      }
    },

    Drivings(plate, startTime, endTime, pno) {
      this.$router.push({
        path: "/member/cheliangguiji",
        query: {
          plate: plate,
          gmtCreate: startTime,
          gmtModified: endTime,
          pno,
        },
      });
    },
    // async carMap() {
    //   const Data = await AMapLoader.load({
    //     key: "88edd4eddc7608598d7872a5d9e0b096", // 申请好的Web端开发者Key，首次调用 load 时必填
    //   })
    //   window.calcDriving = (plate) => {

    //     this.calcDriving(plate);

    //   };
    //   this.map = new Data.Map("container", {
    //     viewMode: "3D", // 是否为3D地图模式
    //     zoom: 11, // 初始化地图级别
    //     center: [this.lng, this.lat], // 初始化地图中心点位置
    //   })
    //   const markerObj = new Data.Marker({
    //     position: [this.lng, this.lat],
    //     title: this.positioncar.plate,
    //     icon: require("/public/homeImg/icon_truck_blue.png"),
    //     map: this.map,

    //   })
    //   this.map.add(markerObj)
    //   this.infoWindow = new AMap.InfoWindow({
    //     position: [this.lng, this.lat],
    //     // offset: new AMap.Pixel(20, -10),
    //     content: `<div class="map-info" style="font-size:80%;padding:10px 25px 10px 10px">
    //       <div class="info-item">
    //       <span>车牌号:</span>
    //       <span>${this.positioncar.plate || "--"}</span>
    //       </div>
    //       <div class="info-item" style="margin-bottom: 10px;">
    //       <span>车辆状态:</span>
    //       <span>${this.positioncar.vehstate || "--"}</span>
    //       </div>
    //       <div class="info-item" style="margin-bottom: 10px;">
    //       <span>车辆时速:</span>
    //       <span>${this.positioncar.speed || "0"}km/小时</span>
    //       </div>
    //       <div class="info-item" style="margin-bottom: 10px;">
    //       <span>剩余电量:</span>
    //       <span>${this.positioncar.soc || "--"}%</span>
    //       </div>
    //       <div class="info-item" style="margin-bottom: 10px;">
    //       <span>车辆类型:</span>
    //       <span>${this.positioncar.cartype || "--"}</span>
    //       </div>
    //       <div class="info-item" style="margin-bottom: 10px;">
    //       <span>排放标准:</span>
    //       <span>${this.positioncar.discharge || "--"}</span>
    //       </div>
    //       <div class="info-item" style="margin-bottom: 20px;">
    //       <span>所属车队:</span>
    //       <span>${this.positioncar.shortname || "--"}</span>
    //       </div>
    //       <div class="line"></div>
    //       <el-button type="primary"
    //                  style="background: linear-gradient(0deg, #28C0C7 0%, #33D9A4 100%);cursor: pointer; border-radius: 5px; color: #fff;padding: 5px 10px;font-size: 14px;" onClick="calcDriving('${this.positioncar.plate}')">查看车辆轨迹 ></el-button>
    //     </div>`,
    //   });
    //   let _this = this
    //   markerObj.on("click", function () {
    //     _this.infoWindow.open(_this.map);
    //   });
    //   // this.map.setFitView(null, false);

    // },
    // calcDriving(plate) {
    //   this.$router.push({
    //     path: "/member/cheliangguiji",
    //     query: {
    //       plate: plate
    //     }
    //   })
    // }
  },
};
</script>

<style lang="scss" scoped>
.mapdetail {
  width: 100%;
  height: 100%;
  position: relative;

  .map-title {
    padding: 5px 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;

    .close {
      cursor: pointer;
    }

    .inp {
      padding: 10px;
      border: 1px solid #17b6a1;
      border-radius: 5px;
      outline: none;
      background-color: #f8f9fb;
    }

    .search {
      margin-left: 20px;
      // width: 80px;
      height: 30px;
      background: #17b6a1;
      border-radius: 8px;
      font-size: 80%;
      font-family: PingFang SC;
      font-weight: 400;
      color: #fff;
      text-align: center;
      //line-height: 32px;
      padding: 0 10px;
      border: none;
    }
    .title-right {
      font-size: 80%;
    }
  }

  .platelist {
    width: 300px;
    // height: 300px;
    max-height: calc(100% - 180px);
    position: absolute;
    overflow: auto;
    left: 20px;
    z-index: 1;
    top: 100px;
    background-color: #fff;

    .liclass {
      line-height: 40px;
      cursor: pointer;
      padding: 0 20px;
      box-sizing: border-box;
    }
  }

  // #container {
  //     height: calc(100% - 138px);
  // }
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.map-info {
  width: 210px;
  height: 260px;
}
</style>